import { FlexCol } from 'components/primitives/flex';
import { Text } from 'components/primitives/typography';
import { useRouter } from 'next/router';
import Button from 'components/ui/Button/Button';
import { useCloseModal } from 'components/remodal/v2/hooks';
import boatsetterPaths from 'utils/boatsetterPaths';

interface Props {
  censoredEmail: string;
  phoneRef: HTMLInputElement;
}

export default function PhoneExistsModal({ censoredEmail, phoneRef }: Props) {
  const router = useRouter();
  const closeModal = useCloseModal();
  const pushToLogin = () => {
    router.push({
      pathname: boatsetterPaths.logIn,
      query: router.query,
    });
  };

  const onFocus = () => {
    closeModal();
    setTimeout(() => {
      phoneRef?.focus();
    }, 100);
  };

  return (
    <FlexCol gap="20px">
      <Text fWeight={600} fSize="21px">
        This phone number is currently in use
      </Text>
      <Text>
        This phone number is associated with another account: <br />
        <Text fWeight={600}>{censoredEmail}</Text>
      </Text>
      <FlexCol gap="20px">
        <Button onClick={pushToLogin} text="Log in" />
        <Button onClick={onFocus} outline text="Try another number" />
      </FlexCol>
    </FlexCol>
  );
}
